//#region frontend/entrypoints/view-transitions.js
window.addEventListener("pageswap", (e) => {
	if (e.activation?.from?.url === e.activation?.entry?.url) {
		e.viewTransition?.skipTransition();
		return;
	}
});
window.addEventListener("pagereveal", (e) => {
	if (!e.viewTransition) return;
});
//#endregion
